import { Http } from '../../shared';
import { settings } from '../../settings';

export class AccountService {
    constructor() {
        this.http = new Http();
        this.service_url = settings.gateway_api.base_url;
    }

    async getOrders(query) {
        var response = await this.http.get(`${this.service_url}/account/orders?${new URLSearchParams(query)}`);
        var result = {
            data: response.data,
            page_size: response.headers['x-pagination-page-size'],
            page_number: response.headers['x-pagination-page-number'],
            total_size: response.headers['x-pagination-total-size'],
        };
        return result;
    }

    async getDetails() {
        var response = await this.http.get(`${this.service_url}/account/details`);
        var result = {
            data: response.data,
            page_size: response.headers['x-pagination-page-size'],
            page_number: response.headers['x-pagination-page-number'],
            total_size: response.headers['x-pagination-total-size'],
        };
        return result.data;
    }
    async create(data) {
        var response = await this.http.post(this.service_url + '/account', data);
        return response.data;
    }
    async update(data) {
        var response = await this.http.put(this.service_url + '/account/details', data);
        return response.data;
    }
    async delete() {
        var response = await this.http.delete(this.service_url + '/account');
        return response.data;
    }
}
